import { useState } from 'react';
import { useParams } from 'react-router';
import type { MandateError } from 'app/react/utils/mandates/error-handler/error-hander';
import { useFetchMandate } from 'receivable-invoices-js/react/api/queries/fetch-mandate/fetch-mandate';
import { createMandateErrorHandler } from 'receivable-invoices-js/react/utils/mandates';

export function useRouteQuery() {
  const { id } = useParams<{ id: string }>();
  const [errorType, setErrorType] = useState<string | null>(null);

  const handleError = (error: unknown) => {
    try {
      const errorHandler = createMandateErrorHandler({ isSuccessPage: true });
      errorHandler(error as MandateError);
    } catch (processedError) {
      const errorMessage =
        processedError instanceof Error ? processedError.message : 'generic_error';
      setErrorType(errorMessage);
      throw processedError;
    }
  };

  const mandateId = id ?? '';
  const {
    data: mandate,
    isLoading: mandateLoading,
    isError: mandateError,
    refetch,
  } = useFetchMandate({ id: mandateId }, { onError: handleError }, { enabled: Boolean(mandateId) });

  return {
    errorType,
    isError: mandateError,
    isLoading: mandateLoading,
    mandate,
    refetch,
  };
}
